<template>
	<div>
		<v-layout wrap py-3 px-3>
			<v-flex xs7 ma-2>
				<span class="caption">Año</span>
				<date-component
					:date="yearGenerated"
					icon="/static/img/calendar.svg"
					placeholder="Año"
					:only-years="true"
					@on-input="getDate({ model: 'yearGenerated', value: $event })"/>
				<!-- <BaseSelect item-text="name" item-value="id" :height="32" label="Año" :items="years"
					@input="getDate({ model: 'yearGenerated', value: $event })" /> -->
			</v-flex>
			<div class="list-history">
			<app-table
			class="is-not-selectable"
			:rows="records"
			:columns="columns"
			:input-search="false"
			:filter-columns="false"
			:main-list="false"
			>
				<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)" class="is-not-selectable">{{ props.row.yearGenerated }}</td>
					<td v-show="showRow(columns, 2)" class="name-column">{{ getMonthName(props.row.monthGenerated )}}</td>
					<td v-show="showRow(columns, 3)" class="name-column">
						{{ props.row.uniqueCode }}
					</td>
					<td v-show="showRow(columns, 4)" style="max-width: 5%" class="actions">
						<app-tooltip-button
							class="no-movil"
							icon="download"
							text="Descargar"
							:size="16"
							@click-icon="openModalCost(props.row)"
						/>
						<app-tooltip-button
							class="no-movil"
							icon="delete"
							color="error"
							text="Eliminar"
							:size="16"
							@click-icon="openModalDelete(props.row)"
						/>
						<!-- <div class="collapse-menu">
							<v-menu>
								<v-btn dark icon slot="activator">
									<v-icon>more_horiz</v-icon>
								</v-btn>
								<v-list>
									<v-list-tile class="btn-menu-content" @click="openModalCost(props.row)">
										<v-list-tile-title class="menu-content">
											<img
											src="/static/img/actions-list/edit.svg"
											alt="icon-edit"
											class="menu-option-icon"
											width="15px"
											height="15px"
											>
											<span class="ml-1 text-edit-mobile">Editar</span>
										</v-list-tile-title>
									</v-list-tile>
									<v-list-tile class="btn-menu-content" @click="openModalDelete(props.row)">
										<v-list-tile-title class="menu-content">
											<img src="/static/img/actions-list/delete.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
											>
											<span class="ml-1 text-delete-mobile">Eliminar</span>
										</v-list-tile-title>
									</v-list-tile>
								</v-list>
							</v-menu>
						</div> -->
					</td>
				</template>
			</app-table>
		</div>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
			:isLoading="loading"
			hiddenSaveBtn
			@cancel-button-clicked="$emit('close-modal')"
			:is-loading="disabled"
			></modal-sidebar-button>
		</section>
		<v-dialog v-model="dialog" persistent max-width="450">
			<v-card style="border-radius: 10px;">
				<v-card-title>
					<span>Desea Eliminar el ATS con el código {{ rowSelected && rowSelected.uniqueCode ? rowSelected.uniqueCode : '' }}</span>
				</v-card-title>
				<v-card-actions style="display: flex; width: 100%; justify-content: center; align-items: center; gap: 10px;">
					<v-btn
						style="color: white !important;"
						color="error"
						@click="closeDialog">Cancelar</v-btn>
					<v-btn
						style="color: white !important;"
						color="success"
						@click="deleteRow">Eliminar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import BaseInput from '@/components/shared/inputs/base-input';
import BaseSelect from '@/components/shared/inputs/base-select';
import dateComponent from '@/components/autocomplete/date-component';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import { format } from 'date-fns';
import esLocale from 'date-fns/locale/es';

function created() {
	// this.years = Array.from({ length: new Date().getFullYear() - 1999 }, (_, i) => 2000 + i);
	// console.log('yeaars', this.years);
	this.yearGenerated = format('2025', 'YYYY');
	this.loadData();
}

async function loadData() {
	const { data: record } = await this.$http.get(
		`transactional-annexes-history?subsidiaryId=${this.subsidiary.id}&yearGenerated=${this.yearGenerated}`);
	console.log('record::: ', record);
	this.records = record;
}

function getDate({ model, value }) {
	this[model] = format(value, 'YYYY');
	this.loadData();
}

function disabled() {
	return this.$v.$invalid;
}

function openModalCost(row) {
	if (row && row.urlAts) {
		window.open(`${row.urlAts}`, '_blank');
	} else {
		this.showNotification('No se encontro un url válido', 'warning');
	}
}

function openModalDelete(row) {
	this.dialog = true;
	this.rowSelected = { ...row };
}

function closeDialog() {
	this.dialog = false;
	this.rowSelected = null;
	this.loadData();
}

async function deleteRow() {
	try {
		console.error('in process...');
		await this.$http.delete(
			`transactional-annexes-history/${this.rowSelected.id}?subsidiaryId=${this.subsidiary.id}`);
		this.showNotification('Se eliminó correctamente');
		this.closeDialog();
	} catch (error) {
		this.showGenericError();
	}
}

function getMonthName(monthNumber) {
	const date = new Date(2024, monthNumber - 1, 1);
	return format(date, 'MMMM', { locale: esLocale }).toUpperCase();
}

function data() {
	return {
		records: [],
		// years: [],
		yearGenerated: null,
		columns: [
			{
				id: 1,
				name: 'Año',
				tooltip: 'Año',
				value: 'yearGenerated',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Mes',
				tooltip: 'Mes',
				value: 'monthGenerated',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Código',
				tooltip: 'Código Ats',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 4,
				name: 'Acciones',
				tooltip: 'Acciones',
				value: 'actions',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		rowSelected: null,
		dialog: false,
	};
}

function validations() {
	return {
		model: {
			startDate: { required },
			endDate: { required },
		},
	};
}

export default {
	name: 'list-history-ats',
	data,
	created,
	components: {
		BaseInput,
		BaseSelect,
		appTooltipButton,
		dateComponent,
	},
	computed: {
		disabled,
	},
	methods: {
		loadData,
		getDate,
		openModalCost,
		openModalDelete,
		closeDialog,
		getMonthName,
		deleteRow,
	},
	props: {
		subsidiary: {
			type: Object,
			default: {},
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	validations,
};
</script>
<style lang="scss" scoped>
.list-history {
	font-family: font(AvenirRegular) !important;
	font-size: size(small11) !important;
	width: 100%;
	@media (max-width: 1024px) {
		padding: 0;
		margin-top: 0;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/list-history-ats/list-history-ats.vue